import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { OfferSession } from 'app/shared/models/class/session/session';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { SessionService } from 'app/shared/services/session/session.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-admin-offer-session',
  templateUrl: './admin-offer-session.component.html',
  styleUrls: ['./admin-offer-session.component.scss']
})
export class AdminOfferSessionComponent extends SubscriptionBaseComponent implements OnInit {
  @Input() offer: FullOffer;

  @Output() editFinished = new EventEmitter<boolean>();

  sessions: OfferSession[];
  addSession = false;

  actionFormOfferAdmin: string;
  sessionSelected: OfferSession = null;
  actionFormSession: string;
  userConnected: any;

  isLoading = false;

  constructor(
    private sessionService: SessionService,
    private route: ActivatedRoute,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private router: Router,
    private faIconService: FaiconService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
    this.initComponent();
    this.getSessionByOffer();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  showFormSession(): void {
    this.addSession = !this.addSession;
    this.actionFormSession = 'add';
  }

  updateAddSession(event): void {
    this.addSession = event;
    if (!event) { this.getSessionByOffer(); }
  }

  updateSession(event): void {
    this.sessionSelected = event;
    this.actionFormSession = 'edit';
  }

  back(): void {
    this.editFinished.next(true);
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
  }

  private getSessionByOffer(): void {
    this.isLoading = true;
    if (this.offer?.offerKey) {
      this.sessionService.getSessionByOffer(this.offer.offerKey).subscribe({
        next: async sessions => {
          this.sessions = await sessions.filter(s => s.sessionStartDate.toString() !== '0001-01-01T00:00:00Z');
          this.addSession = sessions.length ? false : true;
          this.isLoading = false;
        }
      });
    }
  }

  private initSub(): void {
    // this.subscription
    //   .add(
    //     this.dataService.actionTabSession$.subscribe({
    //       next: action => {

    //         const addSession = {
    //           edit: false,
    //           add: true,
    //         };

    //         this.addSession = addSession[action];
    //         this.cdr.detectChanges();
    //       }
    //     })
    //   );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
